import { isProduction } from "./utils"

export const updateUser = (uid, data) => {
    if (uid) {
        fetch(`${isProduction() ? window.location.origin : 'http://localhost:8080'}/api/users/${uid}`, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(rtta => rtta.json())
            .catch(e => {
                console.log("Error updateUser");
                console.log(e);
            })
    }
    else {
        console.log("Error updateUser! Sin UID!");
    }
}


export const updateDevice = (uid, deviceId, data) => {
    if (uid) {
        fetch(`${isProduction() ? window.location.origin : 'http://localhost:8080'}/api/device/${uid}/${deviceId}`, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(rtta => rtta.json())
            .catch(e => {
                console.log("Error updateUser");
                console.log(e);
            })
    }
    else {
        console.log("Error updateUser! Sin UID!");
    }
}